import script from "./CategoriesBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesBar.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesBar.vue?vue&type=style&index=0&id=de95dfc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de95dfc6"]])

export default __exports__